import type { PlayerTrackingHistoryRemovePayload } from '@modules/players/submodules/PlayerProfile/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  PLAYER_PROFILE_PERMISSIONS,
  PLAYER_TRACKING_HISTORY_QUERY_KEY,
  REMOVE_PLAYER_HISTORY_MUTATION_KEY,
  REMOVE_PLAYER_HISTORY_QUERY_URL,
} from '@modules/players/submodules/PlayerProfile/constants';
import { useToastStore } from '@modules/toast/store';

export default function useTrackingHistoryRemoveMutation(): ReturnType<
    typeof useContextMutation<void, Error, PlayerTrackingHistoryRemovePayload>
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, PlayerTrackingHistoryRemovePayload>({
    mutationKey: [REMOVE_PLAYER_HISTORY_MUTATION_KEY],
    mutationFn: ({ playerId, merchant, historyId }) => fetchDelete<void>(
      REMOVE_PLAYER_HISTORY_QUERY_URL,
      {
        permission: PLAYER_PROFILE_PERMISSIONS.PLAYERS_TRACKING,
        urlParams: {
          playerId,
          historyId,
        },
        queryParams: {
          merchant,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [PLAYER_TRACKING_HISTORY_QUERY_KEY] });
      displayPresetToast('removed');
    },
  });
}
